import store from "../store/index";
import {
	FETCH_POST_TAG_API,
	TAG_ASSOCIATION_API,
	TAG_CHAPTER_ASSOCIATION_API,
} from "../constants/urls";
import ApiHelpers from "../helpers/ApiHelpers";

export const tagService = {
	fetchTags,
	createTag,
	fetchChapterTagAssociations,
	createTagAssociation,
	deleteTagAssociation,
};

async function parseResponse(response) {
	let json = await response.json();
	if (json && json.status === "Error") {
		return Promise.reject(json.error?.message || "Something went wrong");
	}
	return json;
}

async function fetchTags() {
	store.dispatch("appState/startLoading");
	try {
		let response = await ApiHelpers.makeAPICall(
			store.state.appState.apiURL + FETCH_POST_TAG_API,
			"GET",
			null,
			false
		);
		return await parseResponse(response);
	} finally {
		store.dispatch("appState/stopLoading");
	}
}

async function createTag(name) {
	store.dispatch("appState/startLoading");
	try {
		let response = await ApiHelpers.makeAPICall(
			store.state.appState.apiURL + FETCH_POST_TAG_API,
			"POST",
			JSON.stringify({ name }),
			false
		);
		return await parseResponse(response);
	} finally {
		store.dispatch("appState/stopLoading");
	}
}

async function fetchChapterTagAssociations(chapterID) {
	store.dispatch("appState/startLoading");
	try {
		let response = await ApiHelpers.makeAPICall(
			store.state.appState.apiURL + TAG_CHAPTER_ASSOCIATION_API + `/${chapterID}`,
			"GET",
			null,
			false
		);
		return await parseResponse(response);
	} finally {
		store.dispatch("appState/stopLoading");
	}
}

async function createTagAssociation(tagID, entity, entityID) {
	store.dispatch("appState/startLoading");
	try {
		let response = await ApiHelpers.makeAPICall(
			store.state.appState.apiURL + TAG_ASSOCIATION_API,
			"POST",
			JSON.stringify({ tagID, entity, entityID }),
			false
		);
		return await parseResponse(response);
	} finally {
		store.dispatch("appState/stopLoading");
	}
}

async function deleteTagAssociation(associationID) {
	store.dispatch("appState/startLoading");
	try {
		let response = await ApiHelpers.makeAPICall(
			store.state.appState.apiURL + TAG_ASSOCIATION_API + `/${associationID}`,
			"DELETE",
			null,
			false
		);
		return await parseResponse(response);
	} finally {
		store.dispatch("appState/stopLoading");
	}
}
